import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import request from '#api/axios';

import { BoxIcon, Text } from '#atoms';

import * as S from './styles';
import EmptyContent from 'src/refactor_shared/ui/empty-content';

export const LectureSchedule = () => {
  const getCoachSchedules = async () => {
    const res = await request<any>({
      method: 'get',
      url: `/schedules/coach/profile`
    });
    return res.data;
  };
  const { data } = useQuery({
    queryKey: ['schedule'],
    queryFn: () => getCoachSchedules()
  });

  const days = ['일', '월', '화', '수', '목', '금', '토'];
  const hasSchedule = data && Object.values(data).some(v => v);

  return (
    <S.Container>
      <S.LabelBox>
        <Text style={{ fontSize: '18px' }}>수업 일정</Text>
        <Link to="/profile/schedule">
          <BoxIcon type="edit-sharp" onlyIcon size={20} />
        </Link>
      </S.LabelBox>
      {hasSchedule ? (
        <S.ScheduleList>
          {Object.entries(data).map(([day, value]) =>
            value && day !== '7' ? (
              <S.ScheduleItem key={day}>
                <S.DayLabel>{days[Number(day)]}</S.DayLabel>
                <div className="flex flex-col">
                  {(value as Array<{ startAt: string; endAt: string }>).map(
                    ({ startAt, endAt }, index) => {
                      return (
                        <S.TimeLabel key={`${startAt}-${endAt}-${index}`}>
                          {startAt} ~ {endAt}
                        </S.TimeLabel>
                      );
                    }
                  )}
                </div>
              </S.ScheduleItem>
            ) : null
          )}
        </S.ScheduleList>
      ) : (
        <EmptyContent>수업 일정이 없습니다.</EmptyContent>
      )}
    </S.Container>
  );
};
